import { isCorpEmail } from '@/micro/identity'
import { isTestEmail } from '@/micro/test'

export function isAuthorizedEmail(email) {
  return isCorpEmail(email) || isTestEmail(email)
}
